module.exports = __webpack_public_path__ + "img/EOTP_logo.6a4275ac.png";